module.exports = __webpack_public_path__ + "media/images/icons/prev_icon-3877255cf30c44bbfc90c98e809a7fef.svg";